<br/>
<dx-data-grid
    [dataSource]="model.displayItems"
    [remoteOperations]="false"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [showBorders]="true"
    noDataText="{{ 'Keine Display-Artikel' | translate }}"
    (onRowUpdated)="update($event)"
    (onRowRemoved)="onRowRemoved($event)"
    (onRowPrepared)="onDisplayItemPrepared($event)"
>
    <dxo-editing mode="cell" [allowUpdating]="!readOnly('displayEdit')" [allowDeleting]="!readOnly('displayDelete')" [useIcons]="true">
        <dxo-texts confirmDeleteMessage="" confirmDeleteTitle=""></dxo-texts>
    </dxo-editing>
    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="DisplayItemsStateV1"></dxo-state-storing>

    <dxi-column
        dataField="artIdTo"
        caption="{{ 'Artikelnummer' | translate }}"
        [cellTemplate]="templateView ? 'artIdToTpl' : null"
        [allowEditing]="false"
        [width]="150"
    ></dxi-column>
    <div *dxTemplate="let d of 'artIdToTpl'">
        <np-inputControl
            [suppressLabel]="true"
            [showPlaceLabel]="d.data.artIdTo != null"
            field="DISPLAY_ART_ID_TO"
            [system]="d.data.order?.toString()">
            <div slot="content" class="contentSlot">{{ d.data.artIdTo }}</div>
        </np-inputControl>
    </div>

    <dxi-column
        dataField="descriptionShort"
        caption="{{ 'Beschreibung' | translate }}"
        [cellTemplate]="templateView ? 'descShortTpl' : null"
        [allowEditing]="false"
    ></dxi-column>
    <div *dxTemplate="let d of 'descShortTpl'">
        <np-inputControl
            [suppressLabel]="true"
            [showPlaceLabel]="d.data.descriptionShort != null"
            field="DISPLAY_DESCRIPTION_SHORT"
            [system]="d.data.order?.toString()">
            <div slot="content" class="contentSlot">{{ d.data.descriptionShort }}</div>
        </np-inputControl>
    </div>

    <dxi-column
        dataField="quantityMinNumber"
        caption="{{ 'Mindestbestellmenge' | translate }}"
        [cellTemplate]="templateView ? 'qtyMinTpl' : null"
        [allowEditing]="false"
        dataType="number"
        [width]="180"
    ></dxi-column>
    <div *dxTemplate="let d of 'qtyMinTpl'">
        <np-inputControl
            [suppressLabel]="true"
            [showPlaceLabel]="d.data.quantityMinNumber != null"
            field="DISPLAY_QUANTITY_MIN"
            [system]="d.data.order?.toString()">
            <div slot="content" class="contentSlot">{{ d.data.quantityMinNumber }}</div>
        </np-inputControl>
    </div>

    <dxi-column
        dataField="displayCount"
        caption="{{ 'Menge auf Display' | translate }}"
        [cellTemplate]="templateView ? 'displayCountTpl' : null"
        dataType="number"
        [width]="150"
    ></dxi-column>
    <div *dxTemplate="let d of 'displayCountTpl'">
        <np-inputControl
            [suppressLabel]="true"
            [showPlaceLabel]="d.data.displayCount != null"
            field="DISPLAY_PLATZ"
            [system]="d.data.order?.toString()">
            <div slot="content" class="contentSlot">
                <dx-number-box
                    [(value)]="d.data.displayCount"
                    (onValueChanged)="update($event)"
                ></dx-number-box>
            </div>
        </np-inputControl>
    </div>

    <dxi-column
        dataField="disposable"
        caption="{{ 'Disponierbar' | translate }}"
        [cellTemplate]="templateView ? 'disposableTpl' : null"
        dataType="boolean"
        [width]="120"
    ></dxi-column>
    <div *dxTemplate="let d of 'disposableTpl'">
        <np-inputControl
            [suppressLabel]="true"
            [showPlaceLabel]="true"
            field="DISPLAY_DISPONIERBAR"
            [system]="d.data.order?.toString()">
            <div slot="content" class="contentSlot">
                <dx-check-box
                    [(value)]="d.data.disposable"
                    (onValueChanged)="update($event)"
                ></dx-check-box>
            </div>
        </np-inputControl>
    </div>

    <dxi-column
        dataField="purchasePrice"
        caption="{{ 'EK-Preis' | translate }}"
        [cellTemplate]="templateView ? 'purchasePriceTpl' : null"
        [allowEditing]="false"
        dataType="number"
        format="#,##0.00"
        [width]="120"
    ></dxi-column>
    <div *dxTemplate="let d of 'purchasePriceTpl'">
        <np-inputControl
            [suppressLabel]="true"
            [showPlaceLabel]="d.data.purchasePrice != null"
            field="DISPLAY_EK_PREIS"
            [system]="d.data.order?.toString()">
            <div slot="content" class="contentSlot">{{ d.data.purchasePrice | number:'1.2-2' }}</div>
        </np-inputControl>
    </div>

    <dxi-column
        dataField="salesPrice"
        caption="{{ 'VK-Preis' | translate }}"
        [cellTemplate]="templateView ? 'salesPriceTpl' : null"
        [allowEditing]="false"
        dataType="number"
        format="#,##0.00"
        [width]="120"
    ></dxi-column>
    <div *dxTemplate="let d of 'salesPriceTpl'">
        <np-inputControl
            [suppressLabel]="true"
            [showPlaceLabel]="d.data.salesPrice != null"
            field="DISPLAY_VK_PREIS"
            [system]="d.data.order?.toString()">
            <div slot="content" class="contentSlot">{{ d.data.salesPrice | number:'1.2-2' }}</div>
        </np-inputControl>
    </div>
</dx-data-grid>

<div class="display-summary">
    <div>
        <span class="display-summary-label">{{ 'Summe EK' | translate }}:</span>
        {{ sumPurchasePrice | number:'1.2-2' }} EUR
    </div>
    <div>
        <span class="display-summary-label">{{ 'Summe VK' | translate }}:</span>
        {{ sumSalesPrice | number:'1.2-2' }} EUR
    </div>
</div>

<footer class="np-footer">
    <dx-button
        *ngIf="!readOnly('displayNew')"
        stylingMode="outlined"
        type="default"
        text="{{ 'Neuer Display-Artikel' | translate }}"
        (onClick)="showAddItem()"
    ></dx-button>
</footer>

<dx-popup
    [(visible)]="addVisible"
    title="{{ 'Display-Artikel hinzufügen' | translate }}"
    [hideOnOutsideClick]="true"
    position="center"
    [width]="700"
    [height]="380"
>
    <div class="dx-fieldset add-display-fieldset">
        <div class="dx-field">
            <div class="dx-field-label">{{ 'Suchtypen' | translate }}</div>
            <div class="dx-field-value">
                <dx-drop-down-box
                    [(value)]="selectedSearchFields"
                    valueExpr="value"
                    displayExpr="name"
                    [showClearButton]="true"
                    [dataSource]="searchFields"
                >
                    <div *dxTemplate="let data of 'content'">
                        <dx-data-grid
                            [dataSource]="searchFields"
                            keyExpr="value"
                            [closeOnOutsideClick]="false"
                            [selection]="{ mode: 'multiple', showCheckBoxesMode: 'always' }"
                            [hoverStateEnabled]="true"
                            [(selectedRowKeys)]="selectedSearchFields"
                        >
                            <dxi-column dataField="value" caption="{{ 'Value' | translate }}"></dxi-column>
                            <dxi-column dataField="name" caption="{{ 'Name' | translate }}"></dxi-column>
                        </dx-data-grid>
                    </div>
                </dx-drop-down-box>
            </div>
        </div>

        <div class="dx-field">
            <div class="dx-field-label">{{ 'Produkt' | translate }}</div>
            <div class="dx-field-value">
                <dx-select-box
                    [searchEnabled]="true"
                    [dataSource]="productSelectBoxData"
                    valueExpr="supplierPid"
                    [searchTimeout]="400"
                    displayExpr="displayText"
                    searchExpr="supplierPid"
                    [showDataBeforeSearch]="false"
                    indicateLoading="true"
                    [(value)]="selectedSupplierPid"
                    (onValueChanged)="selectedNewProduct = $event.component.option('selectedItem')"
                >
                    <div *dxTemplate="let item of 'item'">
                        <dx-load-indicator [visible]="isLoading"></dx-load-indicator>
                        <span [hidden]="isLoading">
                            {{ item.displayText }}
                        </span>
                    </div>
                </dx-select-box>
            </div>
        </div>

        <div class="dx-field" style="place-self: center;">
            <dx-button
                *ngIf="selectedNewProduct"
                stylingMode="text"
                type="default"
                text="{{ 'Display-Artikel hinzufügen' | translate }}"
                [disabled]="readOnly('displayNew')"
                (onClick)="addDisplayItem()"
            ></dx-button>
        </div>
    </div>
</dx-popup>
